export default {
  path: '/trackers/tracker-manufacturers',
  name: 'TrackerManufacturers',
  component: () => import(/* webpackChunkName: "base" */ '../views/TrackerManufacturersView.vue'),
  meta: {
    exclude: false,
    requiresAuth: true
  }
}
